import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

import type { AuthContextStoreEventData } from '@surglogs-app/types'

import { AuthContext } from '../context'

export const useAuthContext = () => useContext<Auth>(AuthContext)

export const AuthContextDataContext = createContext<AuthContextStoreEventData>({
  userId: null,
  sessionId: null,
})

export const useAuthContextData = () =>
  useContext<AuthContextStoreEventData>(AuthContextDataContext)

interface AuthContextDataProviderProps {
  children: ReactNode
}

export const AuthContextDataProvider = ({
  children,
}: AuthContextDataProviderProps) => {
  const { contextStore } = useAuthContext()
  const [value, setVal] = useState<AuthContextStoreEventData>(() =>
    contextStore.getData(),
  )

  useEffect(() => {
    setVal(contextStore.getData())
    return contextStore.onChange(setVal)
  }, [contextStore])

  return (
    <AuthContextDataContext.Provider {...{ value }}>
      {children}
    </AuthContextDataContext.Provider>
  )
}
